var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 400 150",
    style: {
      enableBackground: "new 0 0 400 150"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#0094D9;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#231F20;}\n\t.st2{fill:#231F20;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M80.9,83.5c5.7-6.9,8.5-15.2,8.5-24.9c0-6.3-1.1-12.4-3.3-18.4c-1.4-3.9-3.2-7-5.4-9.4 c-2.2-2.4-5.1-4.5-8.7-6.1c-5.7-2.6-12.3-3.9-20-3.9c-11.6,0-20.5,2.6-26.6,7.9C18.2,34.7,14.6,45,14.6,59.4 c0,8.2,1.5,15.3,4.5,21.2c4,7.7,10.2,12.6,18.7,14.5c3.3,0.7,6.1,1.2,8.4,1.4c2.4,0.2,6.7,0.3,13,0.3l6.2,0.1h28.4V83.5H80.9z  M68.2,76.2c-3,5.4-8.3,8.1-16,8.1c-8.2,0-13.7-2.9-16.6-8.8C33.5,71,32.4,65.2,32.4,58c0-8.3,1.6-14.5,4.8-18.5 c3.2-4,8.2-6.1,14.8-6.1c7.1,0,12.2,2.5,15.4,7.5c2.8,4.5,4.2,10.2,4.2,17.3C71.6,66.1,70.5,72.1,68.2,76.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M118,24.9v42.8c0,3.4,0.3,6.1,0.8,8c0.6,1.9,1.5,3.5,2.9,4.8c3.1,2.9,7.3,4.4,12.6,4.4c3.4,0,6.4-0.6,9-1.7 c2.6-1.2,4.3-2.7,5.3-4.7c1-2,1.5-5.6,1.5-10.7V24.9h15.3V67c0,5.6-0.6,10.1-1.7,13.7c-1.2,3.6-3,6.5-5.5,8.7 c-5.7,4.9-13.7,7.4-24.2,7.4c-11.1,0-19.2-2.4-24.3-7.3c-2.7-2.5-4.5-5.3-5.5-8.5c-1-3.1-1.5-7.4-1.5-13V24.9H118z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M232.2,24.9v12.7h-20c-5.2,0-9,0.4-11.4,1.1c-2.4,0.7-4.3,2.1-5.9,4.2c-1.1,1.4-1.8,2.9-2.2,4.3 c-0.4,1.4-0.7,3.9-1,7.4h40.5v12.7h-40.5c0.5,6.3,2.3,10.6,5.4,13c3.1,2.4,8.3,3.7,15.8,3.7h19.3v12.7h-20c-5.4,0-10.2-0.3-14.3-1 c-6.5-1-11.6-3.9-15.4-8.5c-5.4-6.6-8.2-15.6-8.2-26.9c0-12.5,3.8-22.3,11.5-29.2c2.6-2.4,5.4-4,8.4-4.9c3-0.9,7-1.4,12-1.4H232.2 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M244.5,96.9V84.2h32.9c5.3,0,8.8-0.5,10.6-1.6c2.5-1.5,3.8-3.8,3.8-6.8c0-3.5-1.5-6.1-4.4-7.7 c-1.7-0.9-4.4-1.4-8.1-1.4h-13.4c-8.2,0-14-1.5-17.6-4.4c-2.2-1.9-4-4.2-5.3-7c-1.3-2.8-1.9-5.8-1.9-9c0-5.1,1.5-9.7,4.4-13.9 c2.9-4,7.5-6.4,13.9-7c2.2-0.2,5.3-0.3,9.6-0.3h35.7v12.7h-32.2c-4.8,0-8,0.3-9.6,0.6c-3.2,0.8-4.9,3.3-4.9,7.4 c0,3.5,1.3,5.8,4.1,7c1.8,0.8,4.9,1.2,9.1,1.2h11.5c5.9,0,10.3,0.5,13.3,1.5c5.1,1.7,8.6,4.7,10.5,9c1.5,3.5,2.3,7.2,2.3,11.2 c0,4.4-1,8.3-3,11.7c-2.8,4.9-7.1,7.8-12.7,8.8c-2.7,0.4-6.9,0.7-12.3,0.7H244.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M321.1,96.9V84.2H354c5.3,0,8.8-0.5,10.6-1.6c2.5-1.5,3.8-3.8,3.8-6.8c0-3.5-1.5-6.1-4.4-7.7 c-1.7-0.9-4.4-1.4-8.1-1.4h-13.4c-8.2,0-14-1.5-17.6-4.4c-2.2-1.9-4-4.2-5.3-7c-1.3-2.8-1.9-5.8-1.9-9c0-5.1,1.5-9.7,4.4-13.9 c2.9-4,7.5-6.4,13.9-7c2.2-0.2,5.4-0.3,9.6-0.3h35.7v12.7h-32.2c-4.8,0-8,0.3-9.6,0.6c-3.2,0.8-4.9,3.3-4.9,7.4 c0,3.5,1.3,5.8,4.1,7c1.8,0.8,4.9,1.2,9.1,1.2h11.5c5.9,0,10.3,0.5,13.3,1.5c5.1,1.7,8.6,4.7,10.5,9c1.5,3.5,2.3,7.2,2.3,11.2 c0,4.4-1,8.3-3,11.7c-2.8,4.9-7.1,7.8-12.7,8.8c-2.7,0.4-6.9,0.7-12.4,0.7H321.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M64.4,129l-3.9-16.2h3.3l2.5,11.1l3-11.1h3.9l2.8,11.3l2.5-11.3h3.3l-4,16.2h-3.4L71.2,117L67.9,129H64.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M86.4,129v-16.2h3.3V129H86.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M96,129v-16.2h3.2l6.6,10.8v-10.8h3V129h-3.3L99,118.5V129H96z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M115.4,129v-16.2h3.2l6.6,10.8v-10.8h3V129H125l-6.5-10.6V129H115.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M134.7,129v-16.2h3.3V129H134.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M144.3,129v-16.2h3.2l6.6,10.8v-10.8h3V129h-3.3l-6.5-10.6V129H144.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M171.2,123.1v-2.7h7v6.4c-1.8,1.7-4.1,2.5-6.9,2.5c-2.7,0-4.7-0.8-6.1-2.4c-1.4-1.6-2.1-3.6-2.1-6.1 c0-2.8,0.8-4.8,2.3-6.2c1.6-1.4,3.5-2.1,5.7-2.1c3.9,0,6.2,1.6,6.9,4.8l-3.2,0.6c-0.5-1.7-1.7-2.6-3.6-2.6c-3.1,0-4.7,1.8-4.7,5.4 c0,1.8,0.4,3.2,1.2,4.2c0.8,1,1.9,1.5,3.4,1.5c1.4,0,2.6-0.5,3.8-1.4v-2.1H171.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M197.4,129v-13.4h-4.8v-2.7h12.9v2.7h-4.8V129H197.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M210,121c0-2.6,0.7-4.7,2.1-6.2c1.4-1.5,3.3-2.3,5.8-2.3c2.8,0,4.8,0.8,6,2.5c1.2,1.7,1.8,3.6,1.8,5.9 c0,2.6-0.7,4.6-2.1,6.1c-1.4,1.5-3.3,2.2-5.7,2.2c-2.5,0-4.4-0.7-5.8-2.2C210.7,125.6,210,123.6,210,121z M213.4,120.9 c0,1.7,0.4,3,1.2,4c0.8,1,1.9,1.5,3.3,1.5c1.5,0,2.6-0.5,3.3-1.6c0.7-1.1,1.1-2.4,1.1-4c0-3.7-1.5-5.5-4.4-5.5 C214.9,115.4,213.4,117.2,213.4,120.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M239,123.1v-2.7h7v6.4c-1.8,1.7-4.1,2.5-6.9,2.5c-2.7,0-4.7-0.8-6.1-2.4c-1.4-1.6-2.1-3.6-2.1-6.1 c0-2.8,0.8-4.8,2.3-6.2c1.6-1.4,3.5-2.1,5.7-2.1c3.9,0,6.2,1.6,6.9,4.8l-3.2,0.6c-0.5-1.7-1.7-2.6-3.6-2.6c-3.1,0-4.7,1.8-4.7,5.4 c0,1.8,0.4,3.2,1.2,4.2c0.8,1,1.9,1.5,3.4,1.5c1.4,0,2.6-0.5,3.8-1.4v-2.1H239z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M252.1,129v-16.2h12v2.7h-8.7v3.6h8.1v2.7h-8.1v4.4h9.1v2.7H252.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M274,129v-13.4h-4.8v-2.7H282v2.7h-4.8V129H274z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M287.3,129v-16.2h3.3v6.4h6.4v-6.4h3.3V129H297V122h-6.4v7.1H287.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M306.7,129v-16.2h12v2.7H310v3.6h8.1v2.7H310v4.4h9.1v2.7H306.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M324.9,129v-16.2h6.9c2.1,0,3.7,0.3,4.8,1c1.1,0.6,1.6,1.8,1.6,3.6c0,2.6-1.4,4.1-4.3,4.5 c1.1,0.6,2.3,1.9,3.6,4l2,3.2h-3.9l-3.5-5.2c-0.3-0.5-0.7-0.9-1.2-1.1c-0.4-0.2-1.1-0.4-2-0.4h-0.7v6.8H324.9z M328.2,119.7h2.4 c1.6,0,2.8-0.1,3.3-0.4c0.6-0.3,0.9-0.8,0.9-1.7c0-0.8-0.2-1.3-0.7-1.6c-0.5-0.3-1.6-0.4-3.3-0.4h-2.5V119.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuess);
export default __webpack_public_path__ + "static/media/Quess.e6513e4c8585e101cf3513fb73dbd90d.svg";
export { ForwardRef as ReactComponent };